/** File / asset upload DTOs used by the platform frontend. */

export const FILE_PURPOSES = [
  'PROFILE_PICTURE',
  'SERVICE_DISPLAY_IMG',
  'JOB_INPUT',
  'JOB_OUTPUT',
  'ARTIFACT',
  'SUPPORT_REQUEST',
  'USER_UPLOAD',
] as const;

/**
 * Asset uploads are limited to media plus common document formats.
 * Mirrors the backend allow-list and powers the FileUpload accept attribute.
 */
export const ASSET_ACCEPTED_FILE_TYPES = [
  'image/*',
  'video/*',
  'audio/*',
  'text/plain',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.txt',
  '.pdf',
  '.doc',
  '.docx',
];

export const ASSET_MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024;

export function createFilePayload(data: Record<string, any> = {}) {
  const project_ids = Array.isArray(data.project_ids)
    ? data.project_ids.filter(Boolean).map((id: any) => String(id))
    : (data.project_id ? [String(data.project_id)] : []);

  return {
    id: data.id ?? null,
    url: data.url || '',
    user_id: data.user_id || null,
    api_key: data.api_key || null,
    created_at: data.created_at || null,
    is_public: data.is_public ?? false,
    file_size_bytes: data.file_size_bytes ?? null,
    content_type: data.content_type || null,
    purpose: data.purpose || 'USER_UPLOAD',
    is_temporary: data.is_temporary ?? false,
    project_ids,
    project_id: data.project_id || project_ids[0] || null,
    display_name: data.display_name || data.file_name || null,
  };
}

export function createUserStorageUsage(data: Record<string, any> = {}) {
  return {
    user_id: data.user_id || null,
    storage_space_bytes: data.storage_space_bytes ?? 0,
    used_storage_bytes: data.used_storage_bytes ?? 0,
    free_storage_bytes: data.free_storage_bytes ?? 0,
  };
}
